import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f2e4cfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "PopTableContainer" }
const _hoisted_2 = {
  style: {"display":"grid"},
  id: "PopTable"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopRow = _resolveComponent("PopRow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTableRef().RowState, (item, index) => {
        return (_openBlock(), _createBlock(_component_PopRow, {
          stateObj: item,
          rowID: index,
          key: index
        }, null, 8, ["stateObj", "rowID"]))
      }), 128))
    ])
  ]))
}